module.exports = __webpack_public_path__ + "img/portfolioVue-Mockup-MacBook.1e526388.jpg";